import React, { useEffect } from 'react'

import "./SideBar.css"
import { useNavigate } from 'react-router-dom';

import { AiOutlineClose } from "react-icons/ai";

interface Props{
    open:Boolean
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
    
}

const SideBar = ({open, setOpen}:Props) => {
    const navigate = useNavigate();
    
  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Función de limpieza para remover la clase si el componente se desmonta
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]); // El efecto se ejecuta cada vez que isSidebarOpen cambia



  return (

    <>
    <div className='SideBar-Component' style={{right:open ? "40vw" : "110vw"}}>


        <div className='SideBar-Header'>


            <div className='Sidebar-Header-logo'>
                <img src='/LogoWhite.png'  />
            </div>

            <div className='SideBar-Header-close'>
                <AiOutlineClose onClick={()=>{setOpen(false)}} style={{cursor:"pointer", color:"#FFF"}}  />
            </div>

        </div>

        <div className='SideBar-Items'>
 

            <div className='SideBar-item' onClick={() =>{navigate("/inicio") ; setOpen(false)}}>
                <span>Inicio</span>
            </div>

            <div className='SideBar-item' onClick={() =>{navigate("/galeria") ; setOpen(false)}}>
                <span>Galeria</span>
            </div>

        </div>


    </div>
    <div className='SideBar-Background' onClick={()=>{setOpen(false)}} style={{display:open ? "flex" : "none"}}>

    </div>
  
    </>
  
  )
}

export default SideBar